export default "__VITE_ASSET__C55hQD6W__"